<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
        <div>
            <div>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                <button (click)="addFolder(node)" mat-icon-button>
                    <mat-icon>create_new_folder</mat-icon>
                </button>
                {{ node.item }}
                <button mat-icon-button (click)="node.editClicked = !node.editClicked"><mat-icon>edit</mat-icon></button>
                <ng-container *ngIf="node.editClicked">
                    <mat-form-field appearance="outline">
                        <mat-label>Folder name</mat-label>
                        <input matInput #itemValue placeholder="Folder name">
                    </mat-form-field>
                    <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
                </ng-container>
                <button (click)="addFile(node)" mat-icon-button>
                    <mat-icon>note_add</mat-icon>
                </button>
            </div>
            <div *ngIf="treeControl.isExpanded(node)">
                <div (click)="openFileDetails(file)" class="pl-48 py-10" *ngFor="let file of node.files" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="mr-10">description</mat-icon>
                    {{ file }}
                </div>
            </div>
        </div>
    </mat-tree-node>
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <!-- use a disabled button to provide padding for tree leaf -->
        <div>
            <div>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                <button (click)="addFolder(node)" mat-icon-button>
                    <mat-icon>create_new_folder</mat-icon>
                </button>
                {{ node.item }}
                <button mat-icon-button (click)="node.editClicked = !node.editClicked"><mat-icon>edit</mat-icon></button>
                <ng-container *ngIf="node.editClicked">
                    <mat-form-field appearance="outline">
                        <mat-label>Folder name</mat-label>
                        <input matInput #itemValue placeholder="Folder name">
                    </mat-form-field>
                    <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
                </ng-container>
                <button (click)="addFile(node)" mat-icon-button>
                    <mat-icon>note_add</mat-icon>
                </button>
            </div>
            <div *ngIf="treeControl.isExpanded(node)">
                <div (click)="openFileDetails(file)" class="pl-48 py-10" *ngFor="let file of node.files" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="mr-10">description</mat-icon>
                    {{ file }}
                </div>
            </div>
        </div>
    </mat-tree-node>
</mat-tree>
<input class="input-file" (change)="onFileSelected($event)" type="file" #file>

<!-- <div class="p-10" *ngIf="FilesNote_DS">
    <div fxLayoutGap="10px" fxLayoutAlign="end center" class="p-10">
        <button (click)="addNewSection()" mat-raised-button>Ajouter un commentaire</button>
        <button (click)="save()" color="primary" mat-raised-button>Enregistrer</button>
    </div>
    <mat-card class="my-10" *ngFor="let item of FilesNote_DS.FilesNote; let i = index">
        <div fxLayoutGap="10px" fxLayoutAlign="end center" class="my-10">
            <button mat-icon-button (click)="deleteSection(i)"><mat-icon>delete</mat-icon></button>
        </div>
        <comment-section [item]="item"></comment-section>
    </mat-card>
</div> -->

<button (click)="save()">Save</button>